module.exports = __webpack_public_path__ + "fonts/StagSans-Light.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Light.otf
// module id = 1084
// module chunks = 0